import { useEffect } from 'react';
import { useState } from 'react';
import { PrivacyPolicyAndTermsAndConditionsLink } from '../../../CommonAssets/Configuration/PrivacyPolicyAndTermsAndConditions';
import { goToUrl } from '../../../Utils/NavigationUtils';
import { LegalInfoType } from './LegalDialogModel';

export type LegalHandler = {
    dialogType: LegalInfoType;
    linkCallBacks: {
        cookiePolicyHandler: () => void;
        privacyPolicyHandler: () => void;
    };
};

function useLegalHandler(type: LegalInfoType): LegalHandler {
    const [dialogType, setDialogType] = useState(type);
    useEffect(() => {
        setDialogType(type);
    }, [type]);

    function openCookiePolicy() {
        document.getElementById('top-anchor')?.scrollIntoView();
        setDialogType(LegalInfoType.CookiePolicy);
    }

    function openPrivacyPolicyLink() {
        goToUrl(PrivacyPolicyAndTermsAndConditionsLink);
    }

    const linkCallBacks = {
        cookiePolicyHandler: openCookiePolicy,
        privacyPolicyHandler: openPrivacyPolicyLink,
    };

    return {
        dialogType,
        linkCallBacks,
    };
}

export default useLegalHandler;
